import React, { useEffect } from 'react';
import PublicHeader from './PublicHeader';
import './AboutPage.css';

const PrivacyPage = () => {
  useEffect(() => {
    document.title = 'Squeekit - Privacy Policy';
  }, []);

  return (
    <div className="about-page">
      <PublicHeader />
      <main className="about-page__main" style={{ maxWidth: '720px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        <h1 style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: '1.5rem', color: 'var(--text-primary, #1a1a1a)' }}>
          Privacy Policy
        </h1>
        <p style={{ marginBottom: '1rem', color: 'var(--text-secondary, #4a4a4a)', lineHeight: 1.6 }}>
          Last updated: February 2025
        </p>

        <section style={{ marginBottom: '1.5rem' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.5rem' }}>1. Information We Collect</h2>
          <p style={{ marginBottom: '0.75rem', lineHeight: 1.6 }}>
            Squeekit collects the following information to provide and improve our window and door quoting services:
          </p>
          <ul style={{ marginLeft: '1.5rem', marginBottom: '0.75rem', lineHeight: 1.7 }}>
            <li><strong>Account information:</strong> Email address, password (hashed), business name, phone number, and address when you create an account or update your profile.</li>
            <li><strong>Contacts:</strong> If you grant permission, we access your device contacts to import customer information for quotes. This data is used only when you choose to import a contact.</li>
            <li><strong>Quote and customer data:</strong> Quotes you create, customer names and details, window types, pricing, and notes. This data is stored to provide the core quoting functionality.</li>
            <li><strong>Jobber integration:</strong> If you connect Squeekit to Jobber, we store OAuth tokens and sync quote and customer data between the apps. We do not store your Jobber password.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.5rem' }}>2. How We Use Your Information</h2>
          <p style={{ marginBottom: '0.75rem', lineHeight: 1.6 }}>
            We use your information to:
          </p>
          <ul style={{ marginLeft: '1.5rem', marginBottom: '0.75rem', lineHeight: 1.7 }}>
            <li>Provide and maintain the Squeekit app and web service</li>
            <li>Authenticate you and manage your account</li>
            <li>Store and sync your quotes and customer data across your devices</li>
            <li>Sync data with Jobber when you have connected your account</li>
            <li>Respond to support requests</li>
          </ul>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.5rem' }}>3. Data Storage and Security</h2>
          <p style={{ marginBottom: '0.75rem', lineHeight: 1.6 }}>
            Your data is stored using Firebase (Google Cloud). We use industry-standard security practices including encryption in transit (HTTPS) and at rest. Passwords are hashed and never stored in plain text.
          </p>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.5rem' }}>4. Third-Party Services</h2>
          <p style={{ marginBottom: '0.75rem', lineHeight: 1.6 }}>
            Squeekit uses:
          </p>
          <ul style={{ marginLeft: '1.5rem', marginBottom: '0.75rem', lineHeight: 1.7 }}>
            <li><strong>Firebase (Google):</strong> Authentication, Firestore database, and Cloud Functions. See <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb' }}>Firebase Privacy</a>.</li>
            <li><strong>Jobber:</strong> When you connect your Jobber account, we exchange quote and customer data with Jobber. See <a href="https://getjobber.com/privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb' }}>Jobber Privacy Policy</a>.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.5rem' }}>5. Your Rights</h2>
          <p style={{ marginBottom: '0.75rem', lineHeight: 1.6 }}>
            You can access, update, or delete your account and data through the app settings. To delete your account and associated data, contact us. We do not sell your personal information.
          </p>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.5rem' }}>6. Contact</h2>
          <p style={{ marginBottom: '0.75rem', lineHeight: 1.6 }}>
            For privacy-related questions, contact us at <a href="mailto:support@squeekit.com" style={{ color: '#2563eb' }}>support@squeekit.com</a>.
          </p>
        </section>
      </main>
    </div>
  );
};

export default PrivacyPage;
